import dayjs from "dayjs";
import i18n from "../i18n";

export const ProjectName = "Loops";
export const DefaultAdminPage = `/manage-user`;
export const DefaultUserPage = `/dashboard`;
// export const ORIGIN = "http://localhost:3000";
// export const ORIGIN = "https://api.invoicemaster.de";
export const ORIGIN = process.env.REACT_APP_API_ORIGIN;
export const ENDPOINT = `${ORIGIN}/api/v1/`;
export const AGENT_ENDPOINT = `${ORIGIN}/api/v1/agent`;
export const Types = {
  1: "admin",
  3: "user",
};

// export const primaryColor = "#678983"; // medium
// export const secondaryColor = "#181D31"; // dark
// export const thirdColor = "#678983E6DDC4"; // light
export const primaryColor = "#073b4c"; // medium

export const secondaryColor = "#073b4c"; // dark
export const thirdColor = "#C4DAD2"; // light
export const BorderFilter = `1px solid ${primaryColor}`;

export const FormatUserName = (userName) => {
  // Replace hyphens with spaces
  let formattedName = userName?.replace(/-/g, " ");

  // Capitalize the first letter of each word
  formattedName = formattedName?.replace(/\b\w/g, function (char) {
    return char?.toUpperCase();
  });

  return formattedName === "Sku" ? "SKU" : formattedName;
};
export const RenderTable = (props, row, index, d, width) =>
  typeof d?.render === "function" ? (
    <>
      <div
        className="d-flex"
        style={{
          flexDirection: d?.align === "right" ? "row-reverse" : "row",
          minWidth: d?.title?.length * (10 + (width || 0)),
        }}
      >
        {d?.render(props, row, index)}
      </div>
    </>
  ) : (
    <>
      <div
        className="d-flex"
        style={{
          flexDirection: d?.align === "right" ? "row-reverse" : "row",
          minWidth: d?.title?.length * (10 + (width || 0)),
        }}
      >
        <span>{props || "-"}</span>
      </div>
    </>
  );
export const ConvertParams = (values) => {
  return Object.entries(
    Object.entries(values)
      .filter(
        ([_, value]) =>
          value &&
          value !== "" &&
          value !== undefined &&
          value !== null &&
          value?.length !== 0
      )
      .reduce((acc, [key, value]) => {
        acc[key] = Array.isArray(value)
          ? value.join(",") // Join arrays with commas
          : encodeURIComponent(value);

        return acc;
      }, {})
  )
    ?.map((d, i) => {
      return `${i === 0 ? "?" : "&"}${d[0]}=${d[1] || ""}`;
    })
    ?.join("");
};

export const AddCommas = (number) => {
  return number?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
};

export function formatNumberOld(No, showCurrency = false) {
  // Convert input to a number
  const number = Number(No);

  // If input is not a valid number, return it as-is
  if (isNaN(number)) {
    return No;
  }

  // Determine the sign of the number
  const isNegative = number < 0;

  // Absolute value for formatting
  const absoluteNumber = Math.abs(number);

  // Use toFixed(2) to ensure exactly 2 decimal places
  const fixedNumber = absoluteNumber.toFixed(2);

  // Split into integer and decimal parts
  const [integerPart, decimalPart] = fixedNumber.toString().split(".");

  // Format the integer part with commas as thousand separators
  const formattedInteger = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ",");

  // Combine the formatted integer and decimal parts
  const formattedNumber = decimalPart
    ? `${formattedInteger}.${decimalPart}`
    : formattedInteger;

  // Add currency symbol if required
  const result = showCurrency ? `${formattedNumber} ﷼` : formattedNumber;

  // Add negative sign if the number was negative
  return isNegative ? `-${result}` : result;
}

export function formatNumber(No, showCurrency = false) {
  const number = Number(No);
  if (isNaN(number)) return No;

  const isNegative = number < 0;
  const absoluteNumber = Math.abs(number);
  const fixedNumber = absoluteNumber.toFixed(2);
  const [integerPart, decimalPart] = fixedNumber.split(".");
  const formattedInteger = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  const formattedNumber = `${formattedInteger}.${decimalPart}`;

  return (
    <span style={{ display: "inline-flex", alignItems: "center", direction: "ltr" }}>
      {isNegative && <span>-</span>}
      {showCurrency && (
        <img
          src="/assets/SAR.png"
          alt="Currency"
          style={{
            height: "1em",
            marginInlineEnd: "6px",
            verticalAlign: "middle",
          }}
        />
      )}
      {formattedNumber}
    </span>
  );
}

export const PaginationConfig = ({
  perPage,
  page,
  totalPage,
  onChange = () => {},
  showSizeChanger = true
}) => {
  // Default values
  return {
    pageSize: perPage,
    current: page,
    total: totalPage,
    onChange: (e, f) => {
      onChange(e, f);
    },
    showSizeChanger: showSizeChanger, // To show page size options
    pageSizeOptions: [10, 20, 50, 100], // Page size options
    showTotal: (total, range) =>
      `${AddCommas(range[0] || 0)}-${AddCommas(range[1] || 0)} of ${AddCommas(
        total || 0
      )} ${i18n.t('config.items', 'items')}`,
  };
};

export const urlDecode = (url) => {
  let newObj = {};
  url?.search
    ?.split("?")[1]
    ?.split("&")
    ?.forEach((e) => {
      const obj = e?.split("=");
      newObj = { ...newObj, [obj[0]]: obj[1] };
    });
  return newObj || {};
};

export const getRangePresets = (t = i18n.t.bind(i18n), { includeLifeTime = true } = {}) => {
  const presets = [
    {
      label: t("config.today", "Today"),
      value: [dayjs().add(0, "d"), dayjs()],
    },
    {
      label: t("config.yesterday", "Yesterday"),
      value: [dayjs().add(-1, "d"), dayjs()],
    },
    {
      label: t("config.last7Days", "Last 7 Days"),
      value: [dayjs().add(-7, "d"), dayjs()],
    },
    {
      label: t("config.last30Days", "Last 30 Days"),
      value: [dayjs().add(-30, "d"), dayjs()],
    },
    {
      label: t("config.last60Days", "Last 60 Days"),
      value: [dayjs().add(-60, "d"), dayjs()],
    },
    {
      label: t("config.last90Days", "Last 90 Days"),
      value: [dayjs().add(-90, "d"), dayjs()],
    },
    {
      label: t("config.thisMonth", "This Month"),
      value: [dayjs().startOf("month"), dayjs().endOf("month")],
    },
    {
      label: t("config.lastMonth", "Last Month"),
      value: [
        dayjs().subtract(1, "month").startOf("month"),
        dayjs().subtract(1, "month").endOf("month"),
      ],
    },
    {
      label: t("config.thisYear", "This Year"),
      value: [dayjs().startOf("year"), dayjs().endOf("year")],
    },
    {
      label: t("config.lastYear", "Last Year"),
      value: [
        dayjs().subtract(1, "year").startOf("year"),
        dayjs().subtract(1, "year").endOf("year"),
      ],
    },
  ];

  if (includeLifeTime) {
    presets.push({
      label: t("config.lifeTime", "Life Time"),
      value: [dayjs("2000-01-01"), dayjs()],
    });
  }

  return presets;
};

export const rangePresets = getRangePresets();

export function capitalizeFirstLetter(str) {
  if (!str || typeof str !== "string") return "";
  return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
}

export function suppressConsoleLogs() {
  if (process.env.NODE_ENV === "production") {
    for (let method of ["log", "warn", "info", "debug"]) {
      console[method] = () => {}; // Replace console methods with no-op
    }
  }
}

export const generateDynamicColumnsWithWidth = (columns, data) => {
  const estimateTextWidth = (text, charWidth = 8) => {
    if (!text) return 0;
    return String(text).length * charWidth;
  };

  const getColumnWidth = (title, sampleData, dataIndex) => {
    const headerWidth = estimateTextWidth(title, 10) + 20; // header + padding/sort icon
    const maxContentWidth = Math.max(
      ...sampleData.map((item) =>
        estimateTextWidth(item?.[dataIndex] ?? "", 8)
      ),
      0
    );
    return Math.max(headerWidth, maxContentWidth) + 0; // extra padding
  };

  return columns.map((col) => {
    // Skip if column has width defined or no dataIndex
    if (col.width || !col.dataIndex) return col;

    const dynamicWidth = getColumnWidth(col.title, data, col.dataIndex);
    return {
      ...col,
      width: dynamicWidth,
    };
  });
};
